import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String
  }

  visitShowPage(event) {
    // Don't trigger if clicking on a link or button inside the row
    if (event.target.closest('a, button')) {
      return
    }
    
    window.location.href = this.urlValue
  }
}
